import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GeneralInfoFormGroup } from '../create-user-form-groups';
import { DropDownItem } from '../../../../../models/shared/stylesheet/drop-down-item';

@Component({
  selector: 'app-create-user-general-form-grid',
  templateUrl: './create-user-general-form-grid.component.html',
  styleUrls: ['./create-user-general-form-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateUserGeneralFormGridComponent {
  @Input({ required: true }) form!: GeneralInfoFormGroup;
  @Input({ required: true }) formSubmitted!: boolean;
  @Input() roleDropdowns: DropDownItem[] = [];

  public customErrorMessages = {
    firstName: { required: $localize`First Name is required` },
    lastName: { required: $localize`Last Name is required` },
    email: {
      required: $localize`Email is required`,
      email: $localize`Please enter a valid email address`
    },
    roleId: { required: $localize`Selection is required` }
  };
}
